import { Component, EventEmitter, OnDestroy, OnInit, Output, inject, signal } from "@angular/core"
import { FormControl, FormGroup, Validators } from "@angular/forms"
import { CONTACT_TITLE_OPTIONS } from "src/app/meta/contact-title-options.const"
import { PATTERNS } from "src/app/meta/patterns.const"
import { PORTING_PROVIDER_OPTIONS } from "src/app/meta/porting-provider-options.const"
import { PortingService } from "src/app/services/porting.service"

@Component({
  selector: "ow-porting-form",
  templateUrl: "./porting-form.component.html"
})
export class PortingFormComponent implements OnInit, OnDestroy {

  @Output() updateValidity = new EventEmitter<boolean>(false)
  
  private readonly portingService = inject(PortingService)

  public readonly TITLE_OPTIONS = CONTACT_TITLE_OPTIONS
  public readonly PROVIDER_OPTIONS = PORTING_PROVIDER_OPTIONS

  public readonly form = new FormGroup({
    porting: new FormControl<boolean>(this.portingService.getPortingData().porting),
    numbersCount: new FormControl<number>(this.portingService.getPortingData().numbersCount),
    number1: new FormControl<string>(this.portingService.getNumber(1)),
    number2: new FormControl<string>(this.portingService.getNumber(2)),
    number3: new FormControl<string>(this.portingService.getNumber(3)),
    number4: new FormControl<string>(this.portingService.getNumber(4)),
    number5: new FormControl<string>(this.portingService.getNumber(5)),
    number6: new FormControl<string>(this.portingService.getNumber(6)),
    number7: new FormControl<string>(this.portingService.getNumber(7)),
    number8: new FormControl<string>(this.portingService.getNumber(8)),
    number9: new FormControl<string>(this.portingService.getNumber(9)),
    number10: new FormControl<string>(this.portingService.getNumber(10)),
    provider: new FormControl<string>(this.portingService.getPortingData().provider),
    owner: new FormControl<"customer" | "billing" | "other">(this.portingService.getPortingData().owner),
    title: new FormControl<string>(this.portingService.getPortingData().title),
    firstName: new FormControl<string>(this.portingService.getPortingData().firstName),
    lastName: new FormControl<string>(this.portingService.getPortingData().lastName),
    streetName: new FormControl<string>(this.portingService.getPortingData().streetName),
    streetNumber: new FormControl<string>(this.portingService.getPortingData().streetNumber),
    postalCode: new FormControl<string>(this.portingService.getPortingData().postalCode),
    city: new FormControl<string>(this.portingService.getPortingData().city)
  })

  public readonly showFields = signal<boolean>(false)
  public readonly numbersCount = signal<number>(1)
  public readonly showAddressFields = signal<boolean>(false)

  private readonly subscriptions = [
    this.form.controls.porting.valueChanges.subscribe((value) => {
      this.onPortingChange()
      if (this.form.controls.porting.valid) {
        this.portingService.setPortingData({ porting: value! })
      }
    }),
    this.form.controls.numbersCount.valueChanges.subscribe((value) => {
      this.onNumbersCountChange()
      if (this.form.controls.numbersCount.valid) {
        this.portingService.setPortingData({ numbersCount: value! })
      }
    }),
    this.form.controls.number1.valueChanges.subscribe((value) => {
      if (this.form.controls.number1.valid) {
        this.portingService.setNumber(1, value!)
      }
    }),
    this.form.controls.number2.valueChanges.subscribe((value) => {
      if (this.form.controls.number2.valid) {
        this.portingService.setNumber(2, value!)
      }
    }),
    this.form.controls.number3.valueChanges.subscribe((value) => {
      if (this.form.controls.number3.valid) {
        this.portingService.setNumber(3, value!)
      }
    }),
    this.form.controls.number4.valueChanges.subscribe((value) => {
      if (this.form.controls.number4.valid) {
        this.portingService.setNumber(4, value!)
      }
    }),
    this.form.controls.number5.valueChanges.subscribe((value) => {
      if (this.form.controls.number5.valid) {
        this.portingService.setNumber(5, value!)
      }
    }),
    this.form.controls.number6.valueChanges.subscribe((value) => {
      if (this.form.controls.number6.valid) {
        this.portingService.setNumber(6, value!)
      }
    }),
    this.form.controls.number7.valueChanges.subscribe((value) => {
      if (this.form.controls.number7.valid) {
        this.portingService.setNumber(7, value!)
      }
    }),
    this.form.controls.number8.valueChanges.subscribe((value) => {
      if (this.form.controls.number8.valid) {
        this.portingService.setNumber(8, value!)
      }
    }),
    this.form.controls.number9.valueChanges.subscribe((value) => {
      if (this.form.controls.number9.valid) {
        this.portingService.setNumber(9, value!)
      }
    }),
    this.form.controls.number10.valueChanges.subscribe((value) => {
      if (this.form.controls.number10.valid) {
        this.portingService.setNumber(10, value!)
      }
    }),
    this.form.controls.provider.valueChanges.subscribe((value) => {
      if (this.form.controls.provider.valid) {
        this.portingService.setPortingData({ provider: value! })
      }
    }),
    this.form.controls.owner.valueChanges.subscribe((value) => {
      this.onOwnerChange()
      if (this.form.controls.owner.valid) {
        this.portingService.setPortingData({ owner: value! })
      }
    }),
    this.form.controls.title.valueChanges.subscribe((value) => {
      if (this.form.controls.title.valid) {
        this.portingService.setPortingData({ title: value! })
      }
    }),
    this.form.controls.firstName.valueChanges.subscribe((value) => {
      if (this.form.controls.firstName.valid) {
        this.portingService.setPortingData({ firstName: value! })
      }
    }),
    this.form.controls.lastName.valueChanges.subscribe((value) => {
      if (this.form.controls.lastName.valid) {
        this.portingService.setPortingData({ lastName: value! })
      }
    }),
    this.form.controls.streetName.valueChanges.subscribe((value) => {
      if (this.form.controls.streetName.valid) {
        this.portingService.setPortingData({ streetName: value! })
      }
    }),
    this.form.controls.streetNumber.valueChanges.subscribe((value) => {
      if (this.form.controls.streetNumber.valid) {
        this.portingService.setPortingData({ streetNumber: value! })
      }
    }),
    this.form.controls.postalCode.valueChanges.subscribe((value) => {
      if (this.form.controls.postalCode.valid) {
        this.portingService.setPortingData({ postalCode: value! })
      }
    }),
    this.form.controls.city.valueChanges.subscribe((value) => {
      if (this.form.controls.city.valid) {
        this.portingService.setPortingData({ city: value! })
      }
    }),
    this.form.statusChanges.subscribe(() => {
      this.updateValidity.emit(this.form.valid)
    })
  ]

  ngOnInit(): void {
    this.onPortingChange()
    this.onNumbersCountChange()
    this.onOwnerChange()
    this.updateValidity.emit(this.form.valid)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe()
    })
  }

  private onPortingChange(): void {
    this.showFields.set(this.form.controls.porting.value!)
    this.updateNumbersValidators()
    this.updateAddressValidators()
    if (this.showFields()) {
      this.form.controls.provider.addValidators(Validators.required)
    } else {
      this.form.controls.provider.clearValidators()
    }
    this.form.controls.provider.updateValueAndValidity()
  }

  private onNumbersCountChange(): void {
    this.numbersCount.set(this.form.controls.numbersCount.value!)
    this.updateNumbersValidators()
  }

  private updateNumbersValidators(): void {
    let i = 1
    while (i <= 10) {
      const control = this.form.get(`number${i}`)
      if (this.form.controls.porting.value && i <= this.numbersCount()) {
        control?.addValidators([Validators.required, Validators.pattern(PATTERNS.NUMERIC)])
      } else {
        control?.clearValidators()
      }
      control?.updateValueAndValidity()
      i++
    }
  }

  private updateAddressValidators(): void {
    if (this.form.controls.porting.value && this.showAddressFields()) {
      this.form.controls.title.addValidators(Validators.required)
      this.form.controls.firstName.addValidators([Validators.required, Validators.maxLength(24)])
      this.form.controls.lastName.addValidators([Validators.required, Validators.maxLength(24)])
      this.form.controls.streetName.addValidators(Validators.required)
      this.form.controls.streetNumber.addValidators(Validators.required)
      this.form.controls.postalCode.addValidators(Validators.required)
      this.form.controls.city.addValidators(Validators.required)
    } else {
      this.form.controls.title.clearValidators()
      this.form.controls.firstName.clearValidators()
      this.form.controls.lastName.clearValidators()
      this.form.controls.streetName.clearValidators()
      this.form.controls.streetNumber.clearValidators()
      this.form.controls.postalCode.clearValidators()
      this.form.controls.city.clearValidators()
    }
    this.form.controls.title.updateValueAndValidity()
    this.form.controls.firstName.updateValueAndValidity()
    this.form.controls.lastName.updateValueAndValidity()
    this.form.controls.streetName.updateValueAndValidity()
    this.form.controls.streetNumber.updateValueAndValidity()
    this.form.controls.postalCode.updateValueAndValidity()
    this.form.controls.city.updateValueAndValidity()
  }

  private onOwnerChange(): void {
    if (this.form.controls.owner.value === "other") {
      this.showAddressFields.set(true)
    } else {
      this.form.controls.title.setValue("")
      this.form.controls.firstName.setValue("")
      this.form.controls.lastName.setValue("")
      this.form.controls.streetName.setValue("")
      this.form.controls.streetNumber.setValue("")
      this.form.controls.postalCode.setValue("")
      this.form.controls.city.setValue("")
      this.showAddressFields.set(false)
    }
    this.updateAddressValidators()
  }

  public addNumber() {
    this.form.controls.numbersCount.setValue(this.form.controls.numbersCount.value! + 1)
  }

  public remNumber() {
    this.form.controls.numbersCount.setValue(this.form.controls.numbersCount.value! - 1)
  }
}
